import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="terms-page">
      {/* Hero Banner */}
      <section className="py-20 bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img 
            src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=1920" 
            alt="Terms and Conditions" 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Terms & <span className="text-green-500">Conditions</span>
          </h1>
          <p className="text-white text-xl max-w-3xl mx-auto">
            Please read these terms and conditions carefully before using our services
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              Welcome to plexgate.ca! These terms and conditions outline the rules and regulations for the use of Plexgate Inc's Website, located at <a href="https://plexgate.ca" className="text-blue-600 hover:underline">https://plexgate.ca</a>.
            </p>

            <p className="text-gray-600 mb-8">
              By accessing this website, we assume you accept these terms and conditions. Do not continue to use plexgate.ca if you do not agree to take all of the terms and conditions stated on this page.
            </p>

            {/* Cookies Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Cookies</h2>
              <p className="text-gray-600 mb-4">
                The website uses cookies to help personalize your online experience. By accessing plexgate.ca, you agreed to use the required cookies.
              </p>
              <p className="text-gray-600 mb-4">
                A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you and can only be read by a web server in the domain that issued the cookie to you.
              </p>
              <p className="text-gray-600">
                We may use cookies to collect, store, and track information for statistical or marketing purposes to operate our website. You have the ability to accept or decline optional Cookies. There are some required Cookies that are necessary for the operation of our website. These cookies do not require your consent as they always work.
              </p>
            </div>

            {/* License Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">License</h2>
              <p className="text-gray-600 mb-4">
                Unless otherwise stated, Plexgate Inc and/or its licensors own the intellectual property rights for all material on plexgate.ca. All intellectual property rights are reserved. You may access this from plexgate.ca for your own personal use subjected to restrictions set in these terms and conditions.
              </p>
              <p className="text-gray-600 mb-2">You must not:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Copy or republish material from plexgate.ca</li>
                <li>Sell, rent, or sub-license material from plexgate.ca</li>
                <li>Reproduce, duplicate or copy material from plexgate.ca</li>
                <li>Redistribute content from plexgate.ca</li>
              </ul>
            </div>

            {/* User Comments Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">User Comments</h2>
              <p className="text-gray-600 mb-4">
                Parts of this website offer users an opportunity to post and exchange opinions and information in certain areas of the website. Plexgate Inc does not filter, edit, publish or review Comments before their presence on the website. Comments do not reflect the views and opinions of Plexgate Inc, its agents, and/or affiliates.
              </p>
              <p className="text-gray-600 mb-2">You warrant and represent that:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so</li>
                <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent, or trademark of any third party</li>
                <li>The Comments do not contain any defamatory, libelous, offensive, indecent, or otherwise unlawful material</li>
                <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity</li>
              </ul>
            </div>

            {/* Hyperlinking Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Hyperlinking to Our Content</h2>
              <p className="text-gray-600 mb-2">The following organizations may link to our Website without prior written approval:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Government agencies</li>
                <li>Search engines</li>
                <li>News organizations</li>
                <li>Online directory distributors</li>
                <li>System-wide Accredited Businesses</li>
              </ul>
              <p className="text-gray-600">
                These organizations may link to our home page, to publications, or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement, or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.
              </p>
            </div>

            {/* Content Liability Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Content Liability</h2>
              <p className="text-gray-600">
                We shall not be held responsible for any content that appears on your Website. You agree to protect and defend us against all claims that are raised on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene, or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
              </p>
            </div>

            {/* Reservation of Rights Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Reservation of Rights</h2>
              <p className="text-gray-600">
                We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amend these terms and conditions and its linking policy at any time.
              </p>
            </div>

            {/* Disclaimer Section */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Disclaimer</h2>
              <p className="text-gray-600 mb-4">
                To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website.
              </p>
              <p className="text-gray-600 mb-2">Nothing in this disclaimer will:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4">
                <li>Limit or exclude our or your liability for death or personal injury</li>
                <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation</li>
                <li>Limit any of our or your liabilities in any way that is not permitted under applicable law</li>
                <li>Exclude any of our or your liabilities that may not be excluded under applicable law</li>
              </ul>
              <p className="text-gray-600">
                As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.
              </p>
            </div>
          </div>

          {/* Contact Section */}
          <div className="mt-12 p-6 bg-gray-50 rounded-lg border-l-4 border-blue-600">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Questions?</h3>
            <p className="text-gray-600 mb-4">
              If you have any questions about these Terms and Conditions, please contact us:
            </p>
            <Link to="/contact" className="text-blue-600 hover:text-blue-700 font-semibold">
              Contact Us →
            </Link>
          </div>

          {/* Last Updated */}
          <div className="mt-8 text-center text-gray-500 text-sm">
            <p>Last Updated: January 2024</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;